import { render } from "./userremote.vue?vue&type=template&id=ea36d31e&ts=true"
import script from "./userremote.vue?vue&type=script&lang=ts"
export * from "./userremote.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__